import { observer } from "mobx-react";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import TablePagination from "@material-ui/core/TablePagination";
import SearchBar from "material-ui-search-bar";
import { debounce } from "@material-ui/core";

export const styles = theme => ({
  root: {
    fontSize: theme.typography.pxToRem(12)
  },
  toolbar: {
    height: 56,
    minHeight: 56,
    paddingTop: 8,
    justifyContent: "flex-end"
  },
  search: {
    marginRight: "1rem"
  }
});

const CustomClipsPaginationBar = observer(
  ({ customClipsStore, showFilters, classes, other }) => (
    <div className={classes.root} {...other}>
      <Toolbar className={classes.toolbar} disableGutters>
        {showFilters && (
          <SearchBar
            value={customClipsStore.description}
            onChange={debounce(
              value => customClipsStore.setDescription(value),
              500
            )}
            onCancelSearch={() => customClipsStore.setDescription("")}
            placeholder="Description"
            className={classes.search}
          />
        )}
        {showFilters && (
          <SearchBar
            value={customClipsStore.gamePk}
            onChange={debounce(value => customClipsStore.setGamePk(value), 500)}
            onCancelSearch={() => customClipsStore.setGamePk("")}
            placeholder="GamePk"
            className={classes.search}
          />
        )}
        <TablePagination
          component="div"
          count={customClipsStore.totalClips}
          rowsPerPage={customClipsStore.clipsPerPage}
          page={customClipsStore.page}
          rowsPerPageOptions={[12, 18, 25]}
          backIconButtonProps={{
            "aria-label": "Previous Page"
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page"
          }}
          labelRowsPerPage="Clips per page:"
          onPageChange={(event, page) => {
            customClipsStore.setPage(page);
          }}
          onRowsPerPageChange={event => {
            customClipsStore.setClipsPerPage(event.target.value);
          }}
        />
      </Toolbar>
    </div>
  )
);

export default withStyles(styles)(CustomClipsPaginationBar);



// WEBPACK FOOTER //
// ./src/containers/CustomClipsPaginationBar.js